<template>
  <div
    class="result-box w-full h-full"
    :style="{ backgroundColor: setBgColorAttendanceStatus(title) }"
  >
    <div class="mb-2 w-full text-center">
      <p class="result-txt text-center mx-auto">{{ numberStudent }}</p>
    </div>
    <div class="result-box__info">
      <p
        class="title text-center font-bold"
        :style="{ color: setColorAttendanceStatus(title) }"
      >
        {{ generateStatus(title) }}
      </p>
    </div>
  </div>
</template>

<script>
import { generateStatus } from "@/helpers/text-helper";
import {
  setBgColorAttendanceStatus,
  setColorAttendanceStatus
} from "../../../../helpers/color";

export default {
  props: ["numberStudent", "title"],
  data() {
    return {
      generateStatus,
      setBgColorAttendanceStatus,
      setColorAttendanceStatus
    };
  }
};
</script>

<style lang="scss" scoped>
.result-box {
  @apply p-2;
  @apply flex flex-col items-center;
  @apply bg-white rounded;

  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12),
    0px 6px 10px rgba(0, 0, 0, 0.14);

  .result-txt {
    @apply text-base font-medium text-[#5d5fef];
    @apply leading-normal;
  }

  .title {
    @apply text-gray-800 font-medium text-base;
  }
}
</style>
